import { render, staticRenderFns } from "./BaseDate.vue?vue&type=template&id=4f078888&scoped=true"
import script from "./BaseDate.vue?vue&type=script&lang=js"
export * from "./BaseDate.vue?vue&type=script&lang=js"
import style0 from "./BaseDate.vue?vue&type=style&index=0&id=4f078888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f078888",
  null
  
)

export default component.exports